export default "__VITE_ASSET__cl6Kjbok__"